export interface IProject {
    project_id: number;
    project_name: string;
    last_modified: Date;
    project_info: object;
    department_id: string | null;
    department_name: string | null;
    url: string;
    team_fk: string;
}

export enum ViewProjectType {
    CARD,
    LIST,
}

export enum ViewProjectSortField {
    NAME,
    LAST_MODIFIED,
    CREATED,
}

export interface IUpdateProject {
    projectName: string;
    projectInfo: object;
    archivedFlag: boolean;
}

export interface IProjectDocument {
    name: string;
    url: string;
    id: string;
}
